import { DATE_FORMATS, INPUT, INPUT_TYPES } from '$gbusiness/enums';
import { input } from '$gbusiness/helpers';
import PAYMENT_METHODS from '$fbusiness/enums/options/paymentMethod';
import { intToArray } from '$gbusiness/helpers/util';
import { dateToString } from '$gbusiness/helpers/date';
import { addBusinessDays } from 'date-fns';

const generateDayOptions = (days) => {
  const thisDay = new Date();
  return intToArray(14).map((v, i) => {
    const deliveryDate = addBusinessDays(thisDay, days + i);
    return {
      value: dateToString(deliveryDate),
      labelText: dateToString(deliveryDate, DATE_FORMATS.DAY_WEEKDAY),
    };
  });
};

export const ADDRESS_FORM = [
  {
    items: [
      {
        ...INPUT_TYPES.GOOGLE_ADDRESS,
        label: 'INPUT.LABEL.SHIPPING_ADDRESS',
        placeholder: 'INPUT.PLACEHOLDER.ADDRESS',
        gridSize: 9,
        value: 'formatted',
        validation: [input.requiredValidation],
      },
    ],
  },
];

export const PAYMENT_FORM = [
  {
    items: [
      {
        input: INPUT.RADIO,
        label: '',
        gridSize: 6,
        value: 'paymentMethod',
        options: PAYMENT_METHODS,
      },
    ],
  },
];

export const getShippingForm = ({ shippingOptions, onChange, shipping }) => [
  {
    items: [
      {
        input: INPUT.RADIO,
        label: '',
        gridSize: 12,
        isMultiline: true,
        value: 'shippingOption',
        options: shippingOptions,
        onChange,
      },
      {
        isHidden: () => true,
        input: INPUT.SELECT,
        label: 'INPUT.LABEL.DELIVERY_DATE',
        value: 'deliveryDate',
        options: generateDayOptions(shipping.days),
        validation: [input.requiredValidation],
      },
    ],
  },
];

export const ADDITIONAL_FORM = [
  {
    items: [
      {
        input: INPUT.TEXTAREA,
        gridSize: 12,
        label: 'INPUT.LABEL.ADDITIONAL_MESSAGE',
        value: 'additionalMessage',
        option: PAYMENT_METHODS,
      },
    ],
  },
];
